export default {
  apiKey: "AIzaSyCw3rRnW3FH0raGgXHldjr_DVzobl0Yr6g",
  authDomain: "project-destination.firebaseapp.com",
  databaseURL: "https://project-destination.firebaseio.com",
  projectId: "project-destination",
  storageBucket: "project-destination.appspot.com",
  messagingSenderId: "502319674475",
};
